import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const temperatureListSelector = createSelector(
  (state: RootState) => state.temperature.temperatureList,
  (temperatureList) => temperatureList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.temperature,
  (item) => item.nextToken !== '',
);

export const isInitTemperatureSelector = createSelector(
  (state: RootState) => state.temperature,
  (item) => item.nextToken !== null,
);
